
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zhuanti",
      function () {
        return require("private-next-pages/zhuanti/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zhuanti"])
      });
    }
  